const getLogos = ({ callback, user, params }) => {
  callback({
    sm:
      'https://framerusercontent.com/images/88mxLxCjH4oyq8wR8A4lgZVVA.svg',
    lg: 'https://framerusercontent.com/images/X3FStMpDiriDow6JsA223ZxatgQ.svg'
  })
}
export default getLogos;
